type Ok<T> = { ok: true; value: T; error: null };
type Err = { ok: false; error: Error };

export type Result<T> = Ok<T> | Err;

export function ok<T>(value: T): Ok<T> {
    return {
        error: null,
        ok: true,
        value,
    };
}

export function err(error: string | Error): Err {
    return {
        error: error instanceof Error ? error : new Error(error),
        ok: false,
    };
}

export function getError(error: unknown): Error {
    if (error instanceof Error) {
        return error;
    }

    return new Error(String(error));
}

export function attempt<T>(fn: () => T): Result<T>;
export function attempt<T>(promise: Promise<T>): Promise<Result<T>>;
export function attempt<T>(fnOrPromise: (() => T) | Promise<T>): Result<T> | Promise<Result<T>> {
    if (fnOrPromise instanceof Promise) {
        return fnOrPromise.then(
            (value) => ok(value),
            (error) => err(getError(error)),
        );
    }

    try {
        const value = fnOrPromise();
        return ok(value);
    } catch (error) {
        return err(getError(error));
    }
}
